import { Lightning } from '@lightningjs/sdk';
import Button, { ButtonTemplateSpec } from 'components/common/buttons/Button';

export type ExpandingButtonTemplateSpec = ButtonTemplateSpec;

export default class ExpandingButton<
    TemplateSpec extends ExpandingButtonTemplateSpec = ExpandingButtonTemplateSpec,
  >
  extends Button<TemplateSpec>
  implements
    Lightning.Component.ImplementTemplateSpec<ExpandingButtonTemplateSpec>
{
  static override _template(): Lightning.Component.Template<Lightning.Component.TemplateSpecLoose> {
    return {
      ...super._template(),
      clipping: true,
      flex: {
        direction: 'row',
        justifyContent: 'flex-start',
        alignItems: 'center',
      },
    };
  }

  protected onExpand() {
    this._Label.visible = true;
    (this as Button).setSmooth('w', this.calculateWidth(true));
  }

  protected onCollapse() {
    this._Label.visible = false;
    (this as Button).setSmooth('w', this.calculateWidth(false));
  }

  protected getIconMarginLeft(expanded: boolean): number {
    return this.paddingH;
  }

  protected setMargin(expanded: boolean) {
    this._StartIcon.patch({
      flexItem: { marginLeft: this.getIconMarginLeft(expanded) },
    });
  }

  override _init() {
    super._init();
    this.setMargin(false);
    this.onCollapse();
  }

  override _focus() {
    super._focus();
    this.setMargin(true);
    this.onExpand();
  }

  override _unfocus() {
    super._unfocus();
    this.setMargin(false);
    this.onCollapse();
  }

  override updateButtonWidth() {
    const expanded = this.hasFocus();
    (this as Button).setSmooth('w', this.calculateWidth(expanded));
  }

  private getCollapsedPadding(): number {
    return this.getIconMarginLeft(false) * 2;
  }

  private calculateWidth(expanded: boolean): number {
    const width = expanded
      ? this.paddingH * 2 +
        this.margin +
        this._StartIcon.renderWidth +
        this._Label.renderWidth
      : this._StartIcon.renderWidth + this.getCollapsedPadding();
    return Math.max(this.minWidth, width);
  }
}
